// 환경 Type
export type ENV_TYPE = 'local' | 'dev' | 'stage' | 'production';

export const PlayStore_Category_List = [
  { text: 'APPLICATION', value: 'APPLICATION' },
  { text: 'ANDROID_WEAR', value: 'ANDROID_WEAR' },
  { text: 'ART_AND_DESIGN', value: 'ART_AND_DESIGN' },
  { text: 'AUTO_AND_VEHICLES', value: 'AUTO_AND_VEHICLES' },
  { text: 'BEAUTY', value: 'BEAUTY' },
  { text: 'BOOKS_AND_REFERENCE', value: 'BOOKS_AND_REFERENCE' },
  { text: 'BUSINESS', value: 'BUSINESS' },
  { text: 'COMICS', value: 'COMICS' },
  { text: 'COMMUNICATION', value: 'COMMUNICATION' },
  { text: 'DATING', value: 'DATING' },
  { text: 'EDUCATION', value: 'EDUCATION' },
  { text: 'ENTERTAINMENT', value: 'ENTERTAINMENT' },
  { text: 'EVENTS', value: 'EVENTS' },
  { text: 'FINANCE', value: 'FINANCE' },
  { text: 'FOOD_AND_DRINK', value: 'FOOD_AND_DRINK' },
  { text: 'HEALTH_AND_FITNESS', value: 'HEALTH_AND_FITNESS' },
  { text: 'HOUSE_AND_HOME', value: 'HOUSE_AND_HOME' },
  { text: 'LIBRARIES_AND_DEMO', value: 'LIBRARIES_AND_DEMO' },
  { text: 'LIFESTYLE', value: 'LIFESTYLE' },
  { text: 'MAPS_AND_NAVIGATION', value: 'MAPS_AND_NAVIGATION' },
  { text: 'MEDICAL', value: 'MEDICAL' },
  { text: 'MUSIC_AND_AUDIO', value: 'MUSIC_AND_AUDIO' },
  { text: 'NEWS_AND_MAGAZINES', value: 'NEWS_AND_MAGAZINES' },
  { text: 'PARENTING', value: 'PARENTING' },
  { text: 'PERSONALIZATION', value: 'PERSONALIZATION' },
  { text: 'PHOTOGRAPHY', value: 'PHOTOGRAPHY' },
  { text: 'PRODUCTIVITY', value: 'PRODUCTIVITY' },
  { text: 'SHOPPING', value: 'SHOPPING' },
  { text: 'SOCIAL', value: 'SOCIAL' },
  { text: 'SPORTS', value: 'SPORTS' },
  { text: 'TOOLS', value: 'TOOLS' },
  { text: 'TRAVEL_AND_LOCAL', value: 'TRAVEL_AND_LOCAL' },
  { text: 'VIDEO_PLAYERS', value: 'VIDEO_PLAYERS' },
  { text: 'WATCH_FACE', value: 'WATCH_FACE' },
  { text: 'WEATHER', value: 'WEATHER' },
  { text: 'GAME', value: 'GAME' },
  { text: 'GAME_ACTION', value: 'GAME_ACTION' },
  { text: 'GAME_ADVENTURE', value: 'GAME_ADVENTURE' },
  { text: 'GAME_ARCADE', value: 'GAME_ARCADE' },
  { text: 'GAME_BOARD', value: 'GAME_BOARD' },
  { text: 'GAME_CARD', value: 'GAME_CARD' },
  { text: 'GAME_CASINO', value: 'GAME_CASINO' },
  { text: 'GAME_CASUAL', value: 'GAME_CASUAL' },
  { text: 'GAME_EDUCATIONAL', value: 'GAME_EDUCATIONAL' },
  { text: 'GAME_MUSIC', value: 'GAME_MUSIC' },
  { text: 'GAME_PUZZLE', value: 'GAME_PUZZLE' },
  { text: 'GAME_RACING', value: 'GAME_RACING' },
  { text: 'GAME_ROLE_PLAYING', value: 'GAME_ROLE_PLAYING' },
  { text: 'GAME_SIMULATION', value: 'GAME_SIMULATION' },
  { text: 'GAME_SPORTS', value: 'GAME_SPORTS' },
  { text: 'GAME_STRATEGY', value: 'GAME_STRATEGY' },
  { text: 'GAME_TRIVIA', value: 'GAME_TRIVIA' },
  { text: 'GAME_WORD', value: 'GAME_WORD' },
  { text: 'FAMILY', value: 'FAMILY' },
];

export const AppStore_Category_List = [
  { text: 'BOOKS', value: 6018 },
  { text: 'BUSINESS', value: 6000 },
  { text: 'CATALOGS', value: 6022 },
  { text: 'EDUCATION', value: 6017 },
  { text: 'ENTERTAINMENT', value: 6016 },
  { text: 'FINANCE', value: 6015 },
  { text: 'FOOD_AND_DRINK', value: 6023 },
  { text: 'GAMES', value: 6014 },
  { text: 'GAMES_ACTION', value: 7001 },
  { text: 'GAMES_ADVENTURE', value: 7002 },
  { text: 'GAMES_ARCADE', value: 7003 },
  { text: 'GAMES_BOARD', value: 7004 },
  { text: 'GAMES_CARD', value: 7005 },
  { text: 'GAMES_CASINO', value: 7006 },
  { text: 'GAMES_DICE', value: 7007 },
  { text: 'GAMES_EDUCATIONAL', value: 7008 },
  { text: 'GAMES_FAMILY', value: 7009 },
  { text: 'GAMES_MUSIC', value: 7011 },
  { text: 'GAMES_PUZZLE', value: 7012 },
  { text: 'GAMES_RACING', value: 7013 },
  { text: 'GAMES_ROLE_PLAYING', value: 7014 },
  { text: 'GAMES_SIMULATION', value: 7015 },
  { text: 'GAMES_SPORTS', value: 7016 },
  { text: 'GAMES_STRATEGY', value: 7017 },
  { text: 'GAMES_TRIVIA', value: 7018 },
  { text: 'GAMES_WORD', value: 7019 },
  { text: 'HEALTH_AND_FITNESS', value: 6013 },
  { text: 'LIFESTYLE', value: 6012 },
  { text: 'MAGAZINES_AND_NEWSPAPERS', value: 6021 },
  { text: 'MAGAZINES_ARTS', value: 13007 },
  { text: 'MAGAZINES_AUTOMOTIVE', value: 13006 },
  { text: 'MAGAZINES_WEDDINGS', value: 13008 },
  { text: 'MAGAZINES_BUSINESS', value: 13009 },
  { text: 'MAGAZINES_CHILDREN', value: 13010 },
  { text: 'MAGAZINES_COMPUTER', value: 13011 },
  { text: 'MAGAZINES_FOOD', value: 13012 },
  { text: 'MAGAZINES_CRAFTS', value: 13013 },
  { text: 'MAGAZINES_ELECTRONICS', value: 13014 },
  { text: 'MAGAZINES_ENTERTAINMENT', value: 13015 },
  { text: 'MAGAZINES_FASHION', value: 13002 },
  { text: 'MAGAZINES_HEALTH', value: 13017 },
  { text: 'MAGAZINES_HISTORY', value: 13018 },
  { text: 'MAGAZINES_HOME', value: 13003 },
  { text: 'MAGAZINES_LITERARY', value: 13019 },
  { text: 'MAGAZINES_MEN', value: 13020 },
  { text: 'MAGAZINES_MOVIES_AND_MUSIC', value: 13021 },
  { text: 'MAGAZINES_POLITICS', value: 13001 },
  { text: 'MAGAZINES_OUTDOORS', value: 13004 },
  { text: 'MAGAZINES_FAMILY', value: 13023 },
  { text: 'MAGAZINES_PETS', value: 13024 },
  { text: 'MAGAZINES_PROFESSIONAL', value: 13025 },
  { text: 'MAGAZINES_REGIONAL', value: 13026 },
  { text: 'MAGAZINES_SCIENCE', value: 13027 },
  { text: 'MAGAZINES_SPORTS', value: 13005 },
  { text: 'MAGAZINES_TEENS', value: 13028 },
  { text: 'MAGAZINES_TRAVEL', value: 13029 },
  { text: 'MAGAZINES_WOMEN', value: 13030 },
  { text: 'MEDICAL', value: 6020 },
  { text: 'MUSIC', value: 6011 },
  { text: 'NAVIGATION', value: 6010 },
  { text: 'NEWS', value: 6009 },
  { text: 'PHOTO_AND_VIDEO', value: 6008 },
  { text: 'PRODUCTIVITY', value: 6007 },
  { text: 'REFERENCE', value: 6006 },
  { text: 'SHOPPING', value: 6024 },
  { text: 'SOCIAL_NETWORKING', value: 6005 },
  { text: 'SPORTS', value: 6004 },
  { text: 'TRAVEL', value: 6003 },
  { text: 'UTILITIES', value: 6002 },
  { text: 'WEATHER', value: 6001 },
];

export const PlayStoreCollections = {
  TOP_FREE: 'TOP_FREE',
  TOP_PAID: 'TOP_PAID',
  GROSSING: 'GROSSING',
  TOP_FREE_GAMES: 'TOP_FREE_GAMES',
  TOP_PAID_GAMES: 'TOP_PAID_GAMES',
  TOP_GROSSING_GAMES: 'TOP_GROSSING_GAMES',
  TRENDING: 'TRENDING',
  NEW_FREE: 'NEW_FREE',
  NEW_PAID: 'NEW_PAID',
  NEW_FREE_GAMES: 'NEW_FREE_GAMES',
  NEW_PAID_GAMES: 'NEW_PAID_GAMES',
};

export const AppStoreCollections = {
  TOP_MAC: 'topmacapps',
  TOP_FREE_MAC: 'topfreemacapps',
  TOP_GROSSING_MAC: 'topgrossingmacapps',
  TOP_PAID_MAC: 'toppaidmacapps',
  NEW_IOS: 'newapplications',
  NEW_FREE_IOS: 'newfreeapplications',
  NEW_PAID_IOS: 'newpaidapplications',
  TOP_FREE_IOS: 'topfreeapplications',
  TOP_FREE_IPAD: 'topfreeipadapplications',
  TOP_GROSSING_IOS: 'topgrossingapplications',
  TOP_GROSSING_IPAD: 'topgrossingipadapplications',
  TOP_PAID_IOS: 'toppaidapplications',
  TOP_PAID_IPAD: 'toppaidipadapplications',
};

export const AppleTypes = [
  { text: 'IOS', value: 'IOS' },
  { text: 'IPAD', value: 'IPAD' },
  { text: 'MAC', value: 'MAC' },
];

/**
 * @description 2자리 코드로 된 국가명
 */
export const Countries2DigitCode = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'AndorrA', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D"Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People"S Republic of', code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People"S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];

export const country_LangCode = [
  {
    code: 'AF',
    langCode: 'af',
    name: 'Afghanistan',
  },
  {
    code: 'DZ',
    langCode: 'dz',
    name: 'Algeria',
  },
  {
    code: 'AS',
    langCode: 'as',
    name: 'American Samoa',
  },
  {
    code: 'AR',
    langCode: 'ar',
    name: 'Argentina',
  },
  {
    code: 'AM',
    langCode: 'am',
    name: 'Armenia',
  },
  {
    code: 'AZ',
    langCode: 'az',
    name: 'Azerbaijan',
  },
  {
    code: 'BS',
    langCode: 'bs',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    langCode: 'bh',
    name: 'Bahrain',
  },
  {
    code: 'BE',
    langCode: 'be',
    name: 'Belgium',
  },
  {
    code: 'BM',
    langCode: 'bm',
    name: 'Bermuda',
  },
  {
    code: 'BO',
    langCode: 'bo',
    name: 'Bolivia',
  },
  {
    code: 'BA',
    langCode: 'ba',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BR',
    langCode: 'br',
    name: 'Brazil',
  },
  {
    code: 'IO',
    langCode: 'io',
    name: 'British Indian Ocean Territory',
  },
  {
    code: 'BN',
    langCode: 'bn',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    langCode: 'bg',
    name: 'Bulgaria',
  },
  {
    code: 'BI',
    langCode: 'bi',
    name: 'Burundi',
  },
  {
    code: 'CA',
    langCode: 'ca',
    name: 'Canada',
  },
  {
    code: 'CV',
    langCode: 'cv',
    name: 'Cape Verde',
  },
  {
    code: 'KY',
    langCode: 'ky',
    name: 'Cayman Islands',
  },
  {
    code: 'CO',
    langCode: 'co',
    name: 'Colombia',
  },
  {
    code: 'KM',
    langCode: 'km',
    name: 'Comoros',
  },
  {
    code: 'CR',
    langCode: 'cr',
    name: 'Costa Rica',
  },
  {
    code: 'HR',
    langCode: 'hr',
    name: 'Croatia',
  },
  {
    code: 'CU',
    langCode: 'cu',
    name: 'Cuba',
  },
  {
    code: 'CY',
    langCode: 'cy',
    name: 'Cyprus',
  },
  {
    code: 'SV',
    langCode: 'sv',
    name: 'El Salvador',
  },
  {
    code: 'EE',
    langCode: 'ee',
    name: 'Estonia',
  },
  {
    code: 'ET',
    langCode: 'et',
    name: 'Ethiopia',
  },
  {
    code: 'FO',
    langCode: 'fo',
    name: 'Faroe Islands',
  },
  {
    code: 'FJ',
    langCode: 'fj',
    name: 'Fiji',
  },
  {
    code: 'FI',
    langCode: 'fi',
    name: 'Finland',
  },
  {
    code: 'FR',
    langCode: 'fr',
    name: 'France',
  },
  {
    code: 'GA',
    langCode: 'ga',
    name: 'Gabon',
  },
  {
    code: 'DE',
    langCode: 'de',
    name: 'Germany',
  },
  {
    code: 'GL',
    langCode: 'gl',
    name: 'Greenland',
  },
  {
    code: 'GD',
    langCode: 'gd',
    name: 'Grenada',
  },
  {
    code: 'GU',
    langCode: 'gu',
    name: 'Guam',
  },
  {
    code: 'GN',
    langCode: 'gn',
    name: 'Guinea',
  },
  {
    code: 'HT',
    langCode: 'ht',
    name: 'Haiti',
  },
  {
    code: 'HU',
    langCode: 'hu',
    name: 'Hungary',
  },
  {
    code: 'IS',
    langCode: 'is',
    name: 'Iceland',
  },
  {
    code: 'ID',
    langCode: 'id',
    name: 'Indonesia',
  },
  {
    code: 'IE',
    langCode: 'ie',
    name: 'Ireland',
  },
  {
    code: 'IT',
    langCode: 'it',
    name: 'Italy',
  },
  {
    code: 'JP',
    langCode: 'ja',
    name: 'Japan',
  },
  {
    code: 'KI',
    langCode: 'ki',
    name: 'Kiribati',
  },
  {
    code: 'KR',
    langCode: 'ko',
    name: 'Korea, Republic of',
  },
  {
    code: 'KW',
    langCode: 'kw',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    langCode: 'kg',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    langCode: 'la',
    name: 'Lao People&quot;S Democratic Republic',
  },
  {
    code: 'LV',
    langCode: 'lv',
    name: 'Latvia',
  },
  {
    code: 'LB',
    langCode: 'lb',
    name: 'Lebanon',
  },
  {
    code: 'LI',
    langCode: 'li',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    langCode: 'lt',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    langCode: 'lu',
    name: 'Luxembourg',
  },
  {
    code: 'MK',
    langCode: 'mk',
    name: 'Macedonia, The Former Yugoslav Republic of',
  },
  {
    code: 'MG',
    langCode: 'mg',
    name: 'Madagascar',
  },
  {
    code: 'MY',
    langCode: 'my',
    name: 'Malaysia',
  },
  {
    code: 'ML',
    langCode: 'ml',
    name: 'Mali',
  },
  {
    code: 'MT',
    langCode: 'mt',
    name: 'Malta',
  },
  {
    code: 'MH',
    langCode: 'mh',
    name: 'Marshall Islands',
  },
  {
    code: 'MR',
    langCode: 'mr',
    name: 'Mauritania',
  },
  {
    code: 'MN',
    langCode: 'mn',
    name: 'Mongolia',
  },
  {
    code: 'MS',
    langCode: 'ms',
    name: 'Montserrat',
  },
  {
    code: 'NA',
    langCode: 'na',
    name: 'Namibia',
  },
  {
    code: 'NR',
    langCode: 'nr',
    name: 'Nauru',
  },
  {
    code: 'NL',
    langCode: 'nl',
    name: 'Netherlands',
  },
  {
    code: 'AN',
    langCode: 'an',
    name: 'Netherlands Antilles',
  },
  {
    code: 'NE',
    langCode: 'ne',
    name: 'Niger',
  },
  {
    code: 'NG',
    langCode: 'ng',
    name: 'Nigeria',
  },
  {
    code: 'NO',
    langCode: 'no',
    name: 'Norway',
  },
  {
    code: 'OM',
    langCode: 'om',
    name: 'Oman',
  },
  {
    code: 'PS',
    langCode: 'ps',
    name: 'Palestinian Territory, Occupied',
  },
  {
    code: 'PA',
    langCode: 'pa',
    name: 'Panama',
  },
  {
    code: 'PL',
    langCode: 'pl',
    name: 'Poland',
  },
  {
    code: 'PT',
    langCode: 'pt',
    name: 'Portugal',
  },
  {
    code: 'RO',
    langCode: 'ro',
    name: 'Romania',
  },
  {
    code: 'RU',
    langCode: 'ru',
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    langCode: 'rw',
    name: 'RWANDA',
  },
  {
    code: 'KN',
    langCode: 'kn',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'SM',
    langCode: 'sm',
    name: 'San Marino',
  },
  {
    code: 'ST',
    langCode: 'st',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    langCode: 'sa',
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    langCode: 'sn',
    name: 'Senegal',
  },
  {
    code: 'CS',
    langCode: 'cs',
    name: 'Serbia and Montenegro',
  },
  {
    code: 'SC',
    langCode: 'sc',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    langCode: 'sl',
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    langCode: 'sg',
    name: 'Singapore',
  },
  {
    code: 'SK',
    langCode: 'sk',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    langCode: 'si',
    name: 'Slovenia',
  },
  {
    code: 'SO',
    langCode: 'so',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    langCode: 'za',
    name: 'South Africa',
  },
  {
    code: 'ES',
    langCode: 'es',
    name: 'Spain',
  },
  {
    code: 'SD',
    langCode: 'sd',
    name: 'Sudan',
  },
  {
    code: 'SR',
    langCode: 'sr',
    name: 'Suriname',
  },
  {
    code: 'SE',
    langCode: 'se',
    name: 'Sweden',
  },
  {
    code: 'CH',
    langCode: 'ch',
    name: 'Switzerland',
  },
  {
    code: 'TW',
    langCode: 'tw',
    name: 'Taiwan, Province of China',
  },
  {
    code: 'TH',
    langCode: 'th',
    name: 'Thailand',
  },
  {
    code: 'TL',
    langCode: 'tl',
    name: 'Timor-Leste',
  },
  {
    code: 'TG',
    langCode: 'tg',
    name: 'Togo',
  },
  {
    code: 'TK',
    langCode: 'tk',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    langCode: 'to',
    name: 'Tonga',
  },
  {
    code: 'TT',
    langCode: 'tt',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TN',
    langCode: 'tn',
    name: 'Tunisia',
  },
  {
    code: 'TR',
    langCode: 'tr',
    name: 'Turkey',
  },
  {
    code: 'GB',
    langCode: 'en',
    name: 'United Kingdom',
  },
  {
    code: 'US',
    langCode: 'en',
    name: 'United States',
  },
  {
    code: 'UG',
    langCode: 'ug',
    name: 'Uganda',
  },
  {
    code: 'AE',
    langCode: 'ae',
    name: 'United Arab Emirates',
  },
  {
    code: 'UZ',
    langCode: 'uz',
    name: 'Uzbekistan',
  },
  {
    code: 'VE',
    langCode: 've',
    name: 'Venezuela',
  },
  {
    code: 'VI',
    langCode: 'vi',
    name: 'Virgin Islands, U.S.',
  },
];
